import type { EventBuffer } from "../events";
import type { SimState } from "../state";
import { Ev } from "../types";

/** Change state, emitting StateChanged. No transition has a minimum duration. */
export function setState(s: SimState, ev: EventBuffer, to: number): void {
  if (s.state === to) return;
  ev.push(Ev.StateChanged, s.tick, s.state, to);
  s.state = to;
  s.stateTicks = 0;
}
